'use client'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/atoms/select'
import { createURL } from '@/utils/create-url-blog'

export const SelectOrder = ({
  sort,
  currentPage,
  searchTerm,
  selectedCategory,
}: {
  sort: string
  currentPage: number
  searchTerm: string
  selectedCategory: string
}) => {
  return (
    <Select
      defaultValue={sort}
      onValueChange={(value) =>
        (window.location.href = createURL('sort', value, {
          currentPage,
          searchTerm,
          selectedCategory,
          sort,
        }))
      }
    >
      <SelectTrigger aria-label="Ordenar publicações">
        <SelectValue id="order" placeholder="Ordenar publicações" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="-fields.publishedAt">Mais recente</SelectItem>
        <SelectItem value="fields.publishedAt">Mais antiga</SelectItem>
      </SelectContent>
    </Select>
  )
}
